import { render, staticRenderFns } from "./SaleProgram.vue?vue&type=template&id=6be09f4a"
import script from "./SaleProgram.vue?vue&type=script&lang=js"
export * from "./SaleProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports